module.exports = __webpack_public_path__ + "Flag-616.01b4b25cc98e6dfbf67aa5e1bd85ef01.svg";